import { useEffect } from "react";
import { PageShell } from "@/components/PageShell";
import { Hero } from "@/components/Hero";
import { Problem } from "@/components/Problem";
import { Solution } from "@/components/Solution";
import { BeforeAfter } from "@/components/BeforeAfter";
import { Capabilities } from "@/components/Capabilities";
import { HowItWorks } from "@/components/HowItWorks";
import { LegacySystems } from "@/components/LegacySystems";
import { Demonstrations } from "@/components/Demonstrations";
import { ClosingCTA } from "@/components/ClosingCTA";

const Home = () => {
  // Suporte a âncoras vindas de outras páginas (ex.: /#capabilities)
  useEffect(() => {
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => el.scrollIntoView(), 300);
    }
  }, []);

  return (
    <PageShell>
      <Hero />
      <Problem />
      <Solution />
      <BeforeAfter />
      <Capabilities />
      <Demonstrations />
      <HowItWorks />
      <LegacySystems />
      <ClosingCTA />
    </PageShell>
  );
};

export default Home;
